/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Button, ButtonProps, IconButton } from '@mui/material';
import { Refresh } from '@mui/icons-material';

export const RefreshButton = ({
  sx,
  iconOnly = false,
  ...props
}: ButtonProps & { iconOnly?: boolean }) => {
  if (iconOnly) {
    return (
      <IconButton
        sx={{ color: 'text.secondary', ...sx }}
        size="small"
        {...props}
        aria-label="Refresh"
      >
        <Refresh />
      </IconButton>
    );
  }

  return (
    <Button
      variant="text"
      startIcon={<Refresh />}
      sx={{
        color: 'text.secondary',
        textTransform: 'none',
        borderRadius: '8px',
        fontWeight: '600',
        mt: 0.2,
        '& .MuiButton-startIcon': {
          mr: 0.5,
        },
        ...sx,
      }}
      {...props}
    >
      Refresh
    </Button>
  );
};
